import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Slider from 'material-ui/Slider'
import classNames from 'classnames'
import { LIMIT_SCALE } from 'redux/appliedFilters/reducer'
import './zoom.css'

export class Zoom extends Component {

    static propTypes = {
        value: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        scaleStep: PropTypes.number.isRequired,
    }

    render() {
        const { name, label, value, onChange, scaleStep } = this.props

        return (
            <div className={classNames('settings', `${name}-settings`)}>
                <div className={classNames('label', `${name}-label`)}>
                    {label}
                </div>

                <Slider
                    min={1}
                    max={LIMIT_SCALE}
                    step={scaleStep}
                    value={value}
                    className={classNames('slider', `${name}-slider`)}
                    sliderStyle={{marginTop:15, width: 230}}
                    onChange={onChange}
                />
            </div>
        )
    }
}
